"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Popup = /** @class */ (function () {
    function Popup(url, state) {
        this.url = url;
        this.id = state;
    }
    Popup.prototype.open = function () {
        var windowFeatures = getWindowFeatures();
        this.window = window.open(this.url, '_blank', windowFeatures);
    };
    Popup.prototype.getWindowResponse = function (modifier) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var safeClose = false;
            var closedMonitor = setInterval(function () {
                var _a;
                if (!safeClose && ((_a = _this.window) === null || _a === void 0 ? void 0 : _a.closed)) {
                    reject('popup closed by user');
                }
            }, 500);
            var handler = function (event) { return __awaiter(_this, void 0, void 0, function () {
                var _a, status, _b, error, params, modifiedParams;
                var _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!((_c = event === null || event === void 0 ? void 0 : event.data) === null || _c === void 0 ? void 0 : _c.status)) {
                                return [2 /*return*/];
                            }
                            _a = this.getParams(event.data), status = _a.status, _b = _a.error, error = _b === void 0 ? null : _b, params = _a.params;
                            safeClose = true;
                            clearInterval(closedMonitor);
                            this.clear(handler);
                            if (params.state && params.state !== this.id) {
                                return [2 /*return*/, reject("state mismatch")];
                            }
                            if (!(status === 'success' && !error)) return [3 /*break*/, 2];
                            return [4 /*yield*/, modifier(params)];
                        case 1:
                            modifiedParams = _d.sent();
                            return [2 /*return*/, resolve(modifiedParams)];
                        case 2: return [2 /*return*/, reject(error + ": " + params.error_description)];
                    }
                });
            }); };
            window.addEventListener('message', handler, false);
        });
    };
    Popup.prototype.getParams = function (data) {
        var status = data.status, params = data.params;
        return { status: status, error: params.error, params: params };
    };
    Popup.prototype.clear = function (handler) {
        var _a;
        window.removeEventListener('message', handler);
        (_a = this.window) === null || _a === void 0 ? void 0 : _a.close();
    };
    return Popup;
}());
var popupFeatures = {
    titlebar: 0,
    toolbar: 0,
    status: 0,
    menubar: 0,
    resizable: 0,
    height: 700,
    width: 1200,
};
var getWindowFeatures = function () {
    var f = [];
    for (var feature in popupFeatures) {
        f.push(feature + "=" + popupFeatures[feature]);
    }
    return f.join(',');
};
exports.default = Popup;
